<ng-container *ngIf="display$ | async">

  <ng-container *ngIf="viewModel$ | async as vm">
    <app-dataset-card (click)="selectHumidity(vm.module)"
      [selected]="sidebarRoomService.isSelected(vm.card, vm.module, GraphType.HUMIDITY)"
      [backgroundColor]="'var(--blue-10)'"
      [hoverBackgroundColor]="'var(--blue-5)'">
      <app-dataset-card-label>{{ 'common-app.__HUMIDITY' | LANG }}</app-dataset-card-label>
      <app-dataset-card-value class="text-blue">{{ (vm.module.Humidity || vm.module.Humidity === 0) && !sidebarRoomService.displayModuleUnreachableIcon(vm.module, vm.modules)  ? vm.module.Humidity : '--' }}</app-dataset-card-value>
      <app-dataset-card-unit>
        <app-text unit [measureType]="EnumMeasureTypes.HUMIDITY"></app-text>
      </app-dataset-card-unit>
      <app-dataset-card-preview [module]="vm.module" [measureType]="EnumMeasureTypes.HUMIDITY"></app-dataset-card-preview>
    </app-dataset-card>
  </ng-container>

</ng-container>
